export const FETCH_OVERVIEW_REPORT = 'overviewReport/FETCH_OVERVIEW_REPORT'
export const FETCH_OVERVIEW_CSV_REPORT = 'overviewReport/FETCH_OVERVIEW_CSV_REPORT'
export const FETCH_CAMPAIGNS_FOR_OPTIONS = 'overviewReport/FETCH_CAMPAIGNS_FOR_OPTIONS'
export const FETCH_CAMPAIGN_LEVEL_REPORT = 'overviewReport/FETCH_CAMPAIGN_LEVEL_REPORT'
export const FETCH_CAMPAIGN_LEVEL_CSV_REPORT = 'overviewReport/FETCH_CAMPAIGN_LEVEL_CSV_REPORT'